import React from 'react';
import { AtSignIcon, GlobeIcon, MailIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { FretDivider } from './Ornaments';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-54" data-mp="32lrmvfnoh1l1">
      <div className="rounded-2xl border border-emerald-200 bg-white p-8 text-center shadow-sm md:p-12" data-id="element-55" data-mp="36oy0x9h17x22">
        <ShieldCheckIcon className="mx-auto h-14 w-14 text-emerald-700" aria-hidden="true" data-id="element-56" data-mp="3uesani6215i3" />
        <h2 className="mt-5 text-3xl font-bold tracking-tight text-stone-900" data-id="element-57" data-mp="3990ijjp5eap">
          GARANTÍA DE 7 DÍAS
        </h2>
        <p className="mt-2 text-sm font-semibold uppercase tracking-[0.12em] text-emerald-700" data-id="element-58" data-mp="3ldap3k9vobm0">
          Recibís el kit y podés revisar el material
        </p>
        <FretDivider character="信" className="mt-5" data-id="element-59" data-mp="29zgl41oc4umn" />
        <p className="mt-5 text-stone-700" data-id="element-60" data-mp="29xm0kogz74j3">
          Tenés 7 días para conocer el contenido del KIT MEDICINA TRADICIONAL
          CHINA™. Si necesitás consultar las condiciones de la garantía,
          escribinos por nuestros canales de contacto.
        </p>
      </div>
    </Section>;
}
const footerLinkClass = 'inline-flex items-center gap-2 transition-colors duration-150 hover:text-white';
export function Footer() {
  return <footer className="border-t border-stone-800 bg-stone-900 py-12 text-white" data-id="element-61" data-mp="3v5dfkog732rd">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-62" data-mp="3q7bww4mol5gf">
        <p className="text-2xl text-amber-200/70" aria-hidden="true" data-id="element-63" data-mp="81pg3kxnr1af">
          中醫
        </p>
        <h3 className="mt-2 text-3xl font-bold tracking-[0.06em] text-amber-200" data-id="element-64" data-mp="32vyphf92q4z">
          LUMEN AKASHA™
        </h3>
        <p className="mt-1 text-sm font-semibold tracking-[0.14em] text-white/80" data-id="element-65" data-mp="hsa8gqmqn9kw">
          KIT MEDICINA TRADICIONAL CHINA™
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-white/70" data-id="element-66" data-mp="qthzcnmxd84y">
          Una biblioteca de estudio visual para terapeutas y practicantes que
          quieren seguir aprendiendo y llevar su práctica al siguiente nivel.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-amber-200 sm:flex-row sm:flex-wrap sm:gap-7" data-id="element-67" data-mp="tvw84i1avhgi">
          <a className={footerLinkClass} href={`mailto:${SUPPORT_EMAIL}`} data-id="element-68" data-mp="yuh6ebwzrr2b">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="13siqn065lwfd" />
            {SUPPORT_EMAIL}
          </a>
          <a className={footerLinkClass} href={WHATSAPP_URL} data-id="element-70" data-mp="18ksnl05orwr5">
            <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="1cm450ieepbo9" />
            WhatsApp: {WHATSAPP_LABEL}
          </a>
          <a className={footerLinkClass} href="https://instagram.com/lumen.akasha" data-id="element-72" data-mp="1hjnukegk1avi">
            <AtSignIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1mj8qsh4cb54j" />
            Instagram: @lumen.akasha
          </a>
          <a className={footerLinkClass} href="https://www.lumenakasha.com" data-id="element-74" data-mp="1rhtw2uyg8ezu">
            <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-75" data-mp="3obol19nzf7ee" />
            www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/60" data-id="element-76" data-mp="3tb9krmaz7js6">
          <p data-id="element-77" data-mp="2aevf3w32tu7d">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-78" data-mp="25maqd8z127ap">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
      </div>
    </footer>;
}